module.exports = __webpack_public_path__ + "img/activation-pin.4298c37a.svg";